export const billingErrorMessage = (error, fallback = 'Billing reconciliation request failed.') => {
  if (Number(error?.response?.status) === 429) {
    const retryAfter = Number(error?.response?.headers?.['retry-after']);
    const retryText = Number.isFinite(retryAfter) && retryAfter > 0
      ? ` Try again in about ${retryAfter} second${retryAfter === 1 ? '' : 's'}.`
      : ' Try again in a moment.';
    return `GMER is rate limiting billing requests.${retryText}`;
  }
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  );
};
